var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"content-block"},[_c('div',{staticClass:"icon-block"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.props.img,"alt":""}})]),_c('div',{staticClass:"text-block"},[_c('h6',[_vm._v(_vm._s(_vm.props.title))]),_c('p',[_vm._v(_vm._s(_vm.props.desc))])])])}
var staticRenderFns = []

export { render, staticRenderFns }